import { apiRequest } from './client';

export type PlatformQuestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface PlatformQuestMineEntry {
  status: PlatformQuestStatus;
  note: string | null;
}

export type PlatformQuestType = 'APP_STORE_RATING';

export interface PlatformQuestProgressGroup {
  count: number;
  cap: number;
  rewardCoins: number;
  full: boolean;
}

export function getMyPlatformQuests(token: string) {
  return apiRequest<Partial<Record<PlatformQuestType, PlatformQuestMineEntry>>>('/platform-quests/mine', { token });
}

export function getPlatformQuestProgress(token: string) {
  return apiRequest<Record<PlatformQuestType, PlatformQuestProgressGroup>>('/platform-quests/progress', { token });
}

/** photoUri is a local file:// (or web blob:) URI from the image picker. */
export function submitAppStoreRatingProof(token: string, photoUri: string) {
  const form = new FormData();
  const filename = photoUri.split('/').pop() ?? `rating-${Date.now()}.jpg`;
  const ext = filename.split('.').pop()?.toLowerCase();
  const mime = ext === 'png' ? 'image/png' : 'image/jpeg';
  form.append('photo', { uri: photoUri, name: filename, type: mime } as unknown as Blob);
  return apiRequest<{ status: PlatformQuestStatus }>('/platform-quests/app-store-rating', {
    method: 'POST',
    token,
    form,
  });
}
